import { createContext, useContext, useState, useCallback } from "react";

const LocationContext = createContext(null);

const DEFAULT_LAT = 42.058509;
const DEFAULT_LNG = -87.674739;

export function LocationProvider({ children }) {
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [error, setError] = useState(null);

  const requestLocation = useCallback(() => {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        setLatitude(DEFAULT_LAT);
        setLongitude(DEFAULT_LNG);
        resolve();
        return;
      }
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setLatitude(pos.coords.latitude);
          setLongitude(pos.coords.longitude);
          setError(null);
          resolve();
        },
        () => {
          setLatitude(DEFAULT_LAT);
          setLongitude(DEFAULT_LNG);
          resolve();
        }
      );
    });
  }, []);

  const setManualLocation = useCallback((lat, lng) => {
    setLatitude(lat);
    setLongitude(lng);
    setError(null);
  }, []);

  return (
    <LocationContext.Provider value={{ latitude, longitude, error, requestLocation, setManualLocation }}>
      {children}
    </LocationContext.Provider>
  );
}

export function useLocation() {
  const ctx = useContext(LocationContext);
  if (!ctx) throw new Error("useLocation must be used within LocationProvider");
  return ctx;
}
